module.exports = __webpack_public_path__ + "static/media/vaxtrace-ft.84514986.jpg";